"use strict";

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var config = require("config");

(function () {
  angular.module("app").factory("favoriteLocationsService", ["UserProvider", "placeCloudService", "$q", "LocationItem", "$http", "_", function (userProvider, placeCloudService, $q, LocationItem, $http, _) {
    // This set is for new favorites added to the users pcm web set
    var personalSetName = userProvider.getUser().account + " - " + userProvider.getUser().userName;
    var personalFavoritesSetId = -1;
    // pchen: DA place set without Places
    var personalSet = void 0;
    // array of PCMWeb LocationItems (1 for each place in above set); populated by loadData
    var personalFavoriteLocations = [];

    // This set is for new favorites added to the accounts pcm web set
    var sharedSetName = userProvider.getUser().account;
    var sharedFavoritesSetId = -1;
    // pchen: DA place set without Places
    var sharedSet = void 0;
    // array of PCMWeb LocationItems (1 for each place in above set); populated by loadData
    var sharedFavoriteLocations = [];

    function loadData() {
      // TODO pchen: load favorite places in the background; have "loading..." placeholder in list view
      // sets globals for saving (setids needed for saving new favorites) and viewing favorites
      var personalFavoritesPromise = placeCloudService.getPlaceSetWithName(personalSetName).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            firstPlaceSet = _ref2[0];

        personalSet = firstPlaceSet;
        personalFavoritesSetId = personalSet ? personalSet.Id : -1;
        return getFavoriteLocationsFromSetId(personalFavoritesSetId, { isSharedFavorite: false });
      }).then(function (locations) {
        personalFavoriteLocations = locations;
      });
      var sharedFavoritesPromise = placeCloudService.getPlaceSetWithName(sharedSetName, { useShared: true }).then(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
            firstPlaceSet = _ref4[0];

        sharedSet = firstPlaceSet;
        sharedFavoritesSetId = sharedSet ? sharedSet.Id : -1;
        return getFavoriteLocationsFromSetId(sharedFavoritesSetId, { isSharedFavorite: true });
      }).then(function (locations) {
        sharedFavoriteLocations = locations;
      });

      return $q.all([personalFavoritesPromise, sharedFavoritesPromise]);
    }
    // pchen: isSharedFavorite is only used to set the property in the LocationItem
    function getFavoriteLocationsFromSetId(setId, _ref5) {
      var isSharedFavorite = _ref5.isSharedFavorite;

      if (setId === -1) {
        // set does not exist (yet)
        return $q.resolve([]);
      } else {
        return placeCloudService.getPlaces(setId,
        // filter = ""
        undefined,
        // includePlaces = true
        undefined,
        // readOnlyPublicData
        false).then(function (placeSet) {
          return placeSet.Places.map(function (daPlace) {
            // pchen: move this "DAPlace to Personal/Shared Favorite Location" conversion to LocationItem.module?
            var loc = new LocationItem(daPlace, daPlace.PlaceName);
            loc.IsShared = isSharedFavorite;
            return loc;
          });
        });
      }
    }

    function getAllLocations() {
      // pchen: personal favs override shared favs with same name
      return _.union(personalFavoriteLocations, sharedFavoriteLocations, "Name");
    }

    function getAsSets() {
      return {
        personal: _.assign(personalSet, { Places: personalFavoriteLocations }),
        shared: _.assign(sharedSet, { Places: sharedFavoriteLocations })
      };
    }

    function filterOutFavoriteSets(sets) {
      return sets.filter(function (_ref6) {
        var Id = _ref6.Id;
        return Id !== personalFavoritesSetId && Id !== sharedFavoritesSetId;
      });
    }

    function saveNew(loc, name, isShared) {
      if (canSave(loc)) {

        loc.Name = name;
        loc.IsShared = isShared === true;
        loc.OnlyMine = true;

        return createDASetIfNeeded(isShared).then(function (setId) {
          var dataAnywhereCustomPlace = {
            street: loc.ALKObj.Address.StreetAddress,
            city: loc.ALKObj.Address.City,
            state: loc.ALKObj.Address.State,
            zip: loc.ALKObj.Address.Zip,
            latitude: loc.ALKObj.Coords.Lat,
            longitude: loc.ALKObj.Coords.Lon,
            placeName: name,
            county: loc.ALKObj.Address.County
          };

          return placeCloudService.saveNewPlace(setId, null, dataAnywhereCustomPlace).then(function (resp) {
            loc.Id = resp.Id;
            loc.TypeIcon = "ico-star";
            loc.SetId = setId;
            if (isShared) {
              sharedFavoriteLocations.push(loc);
            } else {
              personalFavoriteLocations.push(loc);
            }
          });
        });
      }
    }

    function canSave(loc) {
      if (!userProvider.getUser().isPremium()) {
        return false;
      }
      if (loc === null || loc === undefined) {
        return false;
      }

      var favs = getAllLocations();

      return userProvider.getUser().isLoggedIn && _.find(favs, function (obj) {
        if (loc.ALKObj && Number(obj.ALKObj.Coords.Lat) === Number(loc.ALKObj.Coords.Lat) && //temporary fix @vani @bpan
        Number(obj.ALKObj.Coords.Lon) === Number(loc.ALKObj.Coords.Lon)) {
          return true;
        } else {
          return false;
        }
      }) === undefined;
    }

    function setSavedSetId(respSet, isShared) {
      if (isShared) {
        sharedFavoritesSetId = respSet.Id;
      } else {
        personalFavoritesSetId = respSet.Id;
      }
    }

    function createDASetIfNeeded(isShared) {
      var deferred = $q.defer();
      var setName = isShared ? sharedSetName : personalSetName;

      placeCloudService.getPlaceSetWithName(setName, { useShared: isShared }).then(function (respSets) {
        if (respSets.length === 0) {
          placeCloudService.addPlaceSet(setName, null, isShared).then(function (respSet) {
            setSavedSetId(respSet, isShared);
            deferred.resolve(respSet.Id);
          });
        } else {
          var respSet = respSets[0];
          setSavedSetId(respSet, isShared);
          deferred.resolve(respSet.Id);
        }
      });

      return deferred.promise;
    }

    function deleteFavorite(fav) {
      $http.delete(config.daUrl + "places/" + fav.Id).success(function () {
        if (fav.isShared) {
          _.remove(sharedFavoriteLocations, fav);
        } else {
          _.remove(personalFavoriteLocations, fav);
        }
      });
    }

    function clearData() {
      personalFavoritesSetId = -1; // This set is for new favorites added to the users pcm web set
      personalFavoriteLocations = [];
      sharedFavoritesSetId = -1; // This set is for new favorites added to the accounts pcm web set
      sharedFavoriteLocations = [];
    }

    return {
      loadData: loadData,
      getAllLocations: getAllLocations,
      getAsSets: getAsSets,
      filterOutFavoriteSets: filterOutFavoriteSets,
      saveNew: saveNew,
      canSave: canSave,
      deleteFavorite: deleteFavorite,
      clearData: clearData
    };
  }]);
})();


// WEBPACK FOOTER //
// ./app/places/favoriteLocations.service.js